<template>
  <custom-popup
    v-model="internalShowTuts"
    :cons="cons"
    :loading.sync="isLoading"
    hide-confirm
    max-width="420"
    @close="stopScanner"
  >
    <v-card class="modern-scanner-card" elevation="0" rounded="xl">
      <div class="text-center pt-6 pb-2 px-4" v-if="isScanning">
        <p class="text-caption grey--text mb-0">کد QR را دقیقاً داخل کادر روشن قرار دهید</p>
      </div>

      <v-card-text class="pa-5">
        <div class="scanner-wrapper">
          
          <!-- حالت پیش‌فرض (دوربین خاموش یا خطا) -->
          <v-fade-transition leave-absolute>
            <div v-if="!isScanning && !isLoading" class="placeholder-state d-flex flex-column align-center justify-center">
              <div class="icon-pulse-wrapper mb-2">
                <v-icon size="72" :color="errorMessage ? 'error' : 'primary lighten-1'">
                  {{ errorMessage ? 'mdi-camera-off' : 'mdi-qrcode-scan' }}
                </v-icon>
              </div>
              <p class="text-body-2 text-center mb-2" :class="errorMessage ? 'error--text px-4' : 'grey--text'">
                {{ errorMessage || 'برای خواندن کد، دوربین را فعال کنید' }}
              </p>
              <v-btn
                class="btn-get-code rounded-lg mt-2"
                elevation="4"
                @click="startScanner"
              >
                <v-icon class="px-2">mdi-camera-iris</v-icon>
                {{ errorMessage ? 'تلاش مجدد' : 'فعال‌سازی دوربین' }}
              </v-btn>
            </div>
          </v-fade-transition>

          <!-- حالت لودینگ -->
          <v-fade-transition leave-absolute>
            <div v-if="isLoading" class="loading-state d-flex flex-column align-center justify-center">
              <v-progress-circular indeterminate color="primary" size="64" width="4"></v-progress-circular>
              <span class="mt-5 text-body-2 grey--text font-weight-medium">در حال اتصال به دوربین...</span>
            </div>
          </v-fade-transition>

          <!-- اسکنر فعال -->
          <v-fade-transition leave-absolute>
            <div v-show="isScanning" class="scanner-container">
              <video ref="videoElement" class="reader-element"></video>
              
              <!-- پوشش تاریک و کادر فوکوس -->
              <div class="scanner-overlay">
                <div class="scanner-cutout">
                  <div class="laser-beam"></div>
                  <div class="corner top-right"></div>
                  <div class="corner top-left"></div>
                  <div class="corner bottom-right"></div>
                  <div class="corner bottom-left"></div>
                </div>
              </div>

              <!-- دکمه تغییر دوربین روی تصویر -->
              <v-btn
                v-if="hasMultipleCameras"
                icon
                dark
                class="switch-camera-btn"
                @click="toggleCamera"
              >
                <v-icon size="28">mdi-camera-flip</v-icon>
              </v-btn>
            </div>
          </v-fade-transition>

        </div>
      </v-card-text>

      <!-- دکمه‌های کنترلی -->
      <v-card-actions class="pb-6 pt-0 justify-center" v-if="isScanning">
        <v-btn
          text
          color="error"
          class="btn-delete rounded-lg"
          @click="stopScanner"
        >
          <v-icon class="px-2">mdi-close-circle-outline</v-icon>
          لغو و بستن دوربین
        </v-btn>
      </v-card-actions>
    </v-card>
  </custom-popup>  
</template>

<script>
import QrScanner from 'qr-scanner';

export default {
  name: 'QrScanner',
  props: {
    showTuts: { 
      type: Boolean, 
      default: false
    },
  },
  data() {
    return {
      cons: { title: 'اسکنر هوشمند', icon: 'qrcode-scan' },
      qrScanner: null,
      isScanning: false,
      isLoading: false,
      scannedData: null,
      errorMessage: '',
      cameraFacingMode: 'environment', // پیش‌فرض: دوربین پشت
      hasMultipleCameras: false,
    };
  },
  computed: {
    internalShowTuts: {
      get() { return this.showTuts; },
      set(value) { this.$emit('update:showTuts', value); }
    }
  },
  watch: {
    internalShowTuts(newVal) {
      if (newVal) {
        this.scannedData = null;
        this.errorMessage = '';
        this.$emit('clear-input'); 
        this.startScanner(); 

      } else {
        this.stopScanner();
      }
    }
  },
   mounted() {
   this.checkCameras();
  },
  beforeDestroy() {
  if (this.qrScanner) {
      this.qrScanner.stop();
      this.qrScanner.destroy(); 
      this.qrScanner = null;
    }
    this.isScanning = false;
  
},
  methods: {
    async checkCameras() {
      try {
        const hasCamera = await QrScanner.hasCamera();
        if (hasCamera) {
          const cameras = await QrScanner.listCameras(true);
          this.hasMultipleCameras = cameras.length > 1;
        }
      } catch (e) {
        console.warn('عدم توانایی در بررسی دوربین‌ها:', e);
      }
    },

    async toggleCamera() {
      if (!this.qrScanner) return;
      this.cameraFacingMode = this.cameraFacingMode === 'environment' ? 'user' : 'environment';
      this.qrScanner.setCamera(this.cameraFacingMode);
    },
//   async startScanner() {
//   this.isLoading = true;
//   this.errorMessage = '';
//   this.isScanning = true;
//   this.scannedData = null;

//   await this.$nextTick();
//   const videoElem = this.$refs.videoElement;

//   try {
//     if (!this.qrScanner) {
//       this.qrScanner = new QrScanner(
//         videoElem,
//         (result) => this.onScanSuccess(result.data || result),
//         {
//           preferredCamera: 'environment',
//           maxScansPerSecond: 30,
//           calculateScanRegion: (video) => {
//             const smallestDimension = Math.min(video.videoWidth, video.videoHeight);
//             const scanRegionSize = Math.round(smallestDimension * 0.75); 
//             return {
//               x: Math.round((video.videoWidth - scanRegionSize) / 2),
//               y: Math.round((video.videoHeight - scanRegionSize) / 2),
//               width: scanRegionSize,
//               height: scanRegionSize,
//             };
//           }
//         }
//       );
//     } else {
//       this.qrScanner.setCamera(this.cameraFacingMode);
//     }

//     await this.qrScanner.start();

//     try {
//       if (videoElem.srcObject) {
//         const track = videoElem.srcObject.getVideoTracks()[0];
//         const capabilities = track.getCapabilities ? track.getCapabilities() : {};
        
//         const basicConstraints = {
//           width: { ideal: 1920 },
//           height: { ideal: 1080 }
//         };
        
//         const advancedConstraints = {};

//         if (capabilities.focusMode && capabilities.focusMode.includes('continuous')) {
//           advancedConstraints.focusMode = 'continuous';
//         }
//         if (capabilities.whiteBalanceMode && capabilities.whiteBalanceMode.includes('continuous')) {
//           advancedConstraints.whiteBalanceMode = 'continuous';
//         }
//         if (capabilities.exposureMode && capabilities.exposureMode.includes('continuous')) {
//           advancedConstraints.exposureMode = 'continuous';
//         } 

//         const currentConstraints = track.getConstraints();
        
//         await track.applyConstraints({
//           ...currentConstraints,
//           ...basicConstraints,
//           ...(Object.keys(advancedConstraints).length > 0 && { advanced: [advancedConstraints] })
//         });
//       }
//     } catch (optimizeError) {
//       console.warn('دستگاه از تنظیمات پیشرفته پشتیبانی نمی‌کند یا محدود شده است:', optimizeError);
//     }
    
//     if (!this.internalShowTuts) {
//       this.stopScanner();
//     }
//   } catch (err) {
//     console.error("خطا در راه‌اندازی دوربین:", err);
//     this.isScanning = false;
    
//     if (err.name === 'NotAllowedError' || err === 'Camera not found.') {
//       this.errorMessage = 'دسترسی به دوربین داده نشده یا دوربینی یافت نشد.';
//     } else {
//       this.errorMessage = 'خطایی در اجرای دوربین رخ داد.';
//     }
//   } finally {
//     this.isLoading = false;
//   }
// },
    async startScanner() {
      this.isLoading = true;
      this.errorMessage = '';
      this.isScanning = true;
      this.scannedData = null;

      await this.$nextTick();
      const videoElem = this.$refs.videoElement;

      // اگر تگ ویدیو در DOM نیست، متوقف شو
      if (!videoElem) {
        this.isLoading = false;
        return;
      }

      // اطمینان از پاکسازی کامل نمونه قبلی قبل از شروع مجدد
      if (this.qrScanner) {
        this.qrScanner.stop();
        this.qrScanner.destroy();
        this.qrScanner = null;
      }

      try {
        // همیشه یک نمونه جدید می‌سازیم تا به تگ ویدیوی فعلی متصل شود
        this.qrScanner = new QrScanner(
          videoElem,
          (result) => this.onScanSuccess(result.data || result),
          {
            // استفاده از cameraFacingMode به جای هاردکد کردن 'environment'
            // تا اگر کاربر دوربین را چرخانده بود، با همان دوربین باز شود
            preferredCamera: this.cameraFacingMode, 
            maxScansPerSecond: 40,
            calculateScanRegion: (video) => {
              const smallestDimension = Math.min(video.videoWidth, video.videoHeight);
              const scanRegionSize = Math.round(smallestDimension * 0.65); 
              return {
                x: Math.round((video.videoWidth - scanRegionSize) / 2),
                y: Math.round((video.videoHeight - scanRegionSize) / 2),
                width: scanRegionSize,
                height: scanRegionSize,
              };
            }
          }
        );

        await this.qrScanner.start();

        // اعمال تنظیمات پیشرفته (فوکوس و ...)
        try {
          if (videoElem.srcObject) {
            const track = videoElem.srcObject.getVideoTracks()[0];
            const capabilities = track.getCapabilities ? track.getCapabilities() : {};
            const advancedConstraints = {};

            if (capabilities.focusMode && capabilities.focusMode.includes('continuous')) {
              advancedConstraints.focusMode = 'continuous';
            }
            if (capabilities.whiteBalanceMode && capabilities.whiteBalanceMode.includes('continuous')) {
              advancedConstraints.whiteBalanceMode = 'continuous';
            }
            if (capabilities.exposureMode && capabilities.exposureMode.includes('continuous')) {
              advancedConstraints.exposureMode = 'continuous';
            } 

            if (Object.keys(advancedConstraints).length > 0) {
              await track.applyConstraints({ advanced: [advancedConstraints] });
            }
          }
        } catch (optimizeError) {
          console.warn('دستگاه از تنظیمات پیشرفته فوکوس در وب پشتیبانی نمی‌کند:', optimizeError);
        }
        
        // جلوگیری از باگ همزمانی (Race condition) اگر در حین لود شدن، مودال بسته شده باشد
        if (!this.internalShowTuts) {
          this.stopScanner();
        }
      } catch (err) {
        console.error("خطا در راه‌اندازی دوربین:", err);
        this.isScanning = false;
        
        if (err.name === 'NotAllowedError' || err === 'Camera not found.') {
          this.errorMessage = 'دسترسی به دوربین داده نشده یا دوربینی یافت نشد.';
        } else {
          this.errorMessage = 'خطایی در اجرای دوربین رخ داد.';
        }
      } finally {
        this.isLoading = false;
      }
    },

    stopScanner() {
      if (this.qrScanner) {
        this.qrScanner.stop();
        this.qrScanner.destroy(); // این خط حتماً باید اجرا شود
        this.qrScanner = null;
      }
      this.isScanning = false;
      this.isLoading = false;
      this.errorMessage = '';
    },
    
    async toggleCamera() {
      if (!this.qrScanner) return;
      this.cameraFacingMode = this.cameraFacingMode === 'environment' ? 'user' : 'environment';
      // بهتر است منتظر نتیجه تغییر دوربین بمانیم
      await this.qrScanner.setCamera(this.cameraFacingMode);
    },

    onScanSuccess(decodedText) {
      let cleanData = decodedText.replace(/^(https?:\/\/)/i, '');
      
      this.scannedData = cleanData;
      this.$emit('decode', cleanData);
      
      this.stopScanner();
      this.$emit('update:showTuts', false);
    }
  }
};
</script>

<style scoped>
.modern-scanner-card { background-color: #ffffff; }
.scanner-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 5;
  border-radius: 20px;
  background-color: #f8f9fa;
  overflow: hidden;
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.05);
}
.placeholder-state, .loading-state {
  position: absolute; inset: 0; width: 100%; height: 100%;
  background: #f8f9fa; border: 2px dashed #e0e0e0; border-radius: 20px;
}
.icon-pulse-wrapper {
  padding: 20px; border-radius: 50%;
  background-color: rgba(25, 118, 210, 0.08);
  animation: pulse-bg 2s infinite ease-in-out;
}
@keyframes pulse-bg {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.2); }
  70% { transform: scale(1); box-shadow: 0 0 0 15px rgba(25, 118, 210, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(25, 118, 210, 0); }
}
.scanner-container {
  position: absolute; inset: 0; width: 100%; height: 100%;
  background-color: #000; border-radius: 20px; overflow: hidden;
}
.reader-element { width: 100%; height: 100%; object-fit: cover; display: block; }
.scanner-overlay { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; z-index: 10; }
.scanner-cutout { width: 70%; aspect-ratio: 1; position: relative; box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.55); border-radius: 16px; }
.laser-beam {
  position: absolute; width: 100%; height: 2px;
  background: linear-gradient(90deg, transparent, #00e676, transparent);
  box-shadow: 0 0 15px 2px rgba(0, 230, 118, 0.6); z-index: 12;
  animation: scanning-laser 2.5s infinite ease-in-out;
}
@keyframes scanning-laser {
  0% { top: 5%; opacity: 0; } 10% { opacity: 1; } 90% { opacity: 1; } 100% { top: 95%; opacity: 0; }
}
.corner { position: absolute; width: 24px; height: 24px; border-color: #00e676; border-style: solid; z-index: 11; animation: corner-pulse 2s infinite; }
@keyframes corner-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
.top-right { top: -2px; right: -2px; border-width: 4px 4px 0 0; border-top-right-radius: 16px; }
.top-left { top: -2px; left: -2px; border-width: 4px 0 0 4px; border-top-left-radius: 16px; }
.bottom-right { bottom: -2px; right: -2px; border-width: 0 4px 4px 0; border-bottom-right-radius: 16px; }
.bottom-left { bottom: -2px; left: -2px; border-width: 0 0 4px 4px; border-bottom-left-radius: 16px; }

/* دکمه جابجایی دوربین */
.switch-camera-btn {
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(4px);
}
</style>
